"use strict";

let angular = require("npm/angular");
import ngMaterial from "npm/angular-material";
import uiRouter from "npm/angular-ui-router";
import "npm/angular-material/angular-material.css";
import Common from "./common/common";
import Components from "./components/components";
import AppComponent from "./app.component";
import ngAnimate from "npm/angular-animate";
import ngMessages from "npm/angular-messages";
import "./app.css";
import "./piko-font.css";
import "./animate.css";
import "./ionicons.css";

const LocalStorage = require("npm/ngstorage/");

angular
  .module("app", [
    uiRouter,
    ngMaterial,
    ngAnimate,
    ngMessages,
    Common.name,
    Components.name,
    "ngStorage"
  ])

  .directive("app", AppComponent)

  .config(($locationProvider, $urlRouterProvider) => {
    "ngInject";
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise("/order/new/basic-info");
  })

  .config($sceDelegateProvider => {
    "ngInject";
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      "self",
      // Allow loading from our assets domain.  Notice the difference between * and **.
      "https://secure.payu.in/_payment",
      "https://test.payu.in/_payment"
    ]);
  })

  .config($mdThemingProvider => {
    "ngInject";
    $mdThemingProvider.definePalette("pickoBlue", {
      "50": "ffebee",
      "100": "ffcdd2",
      "200": "ef9a9a",
      "300": "e57373",
      "400": "ef5350",
      "500": "439fd9",
      "600": "e53935",
      "700": "d32f2f",
      "800": "c62828",
      "900": "b71c1c",
      A100: "ff8a80",
      A200: "ff5252",
      A400: "ff1744",
      A700: "d50000",
      contrastDefaultColor: "light", // whether, by default, text         (contrast)
      // on this palette should be dark or light
      contrastDarkColors: [
        "50",
        "100", //hues which contrast should be 'dark' by default
        "200",
        "300",
        "400",
        "A100"
      ],
      contrastLightColors: undefined // could also specify this if default was 'dark'
    });

    $mdThemingProvider.theme("default").primaryPalette("pickoBlue");
  });



// WEBPACK FOOTER //
// ./client/app/app.js